export function rarityColor(rarityPercentage) {
  if (rarityPercentage >= 30) {
    return 'rgb(101, 208, 101)';
  } else if (rarityPercentage >= 20) {
    return 'rgb(101, 139, 208)';
  } else if (rarityPercentage >= 10) {
    return 'rgb(150, 112, 221)';
  } else if (rarityPercentage >= 5) {
    return 'rgb(221, 112, 197)';
  } else {
    return 'rgb(225, 53, 53)';
  }
}

export function rarityText(rarityPercentage) {
  if (rarityPercentage >= 30) {
    return 'Common';
  } else if (rarityPercentage >= 20) {
    return 'Uncommon';
  } else if (rarityPercentage >= 10) {
    return 'Rare';
  } else if (rarityPercentage >= 5) {
    return 'Epic';
  } else {
    return 'Legendary';
  }
}
